import React, { createContext, useState, useEffect } from 'react';
import api from '../utils/axios.ts';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch user data on mount if token exists
  useEffect(() => {
    const token = localStorage.getItem('userToken');
    if (token) {
      fetchUserData();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await api.get('/members/my-profile');
      const userData = response.data.data || response.data;
      
      // Ensure permissions is an array
      if (userData && !Array.isArray(userData.permissions)) {
        userData.permissions = [];
      }
      
      setUser(userData);
    } catch (error) {
      console.error('Failed to fetch user data:', error);
      // If token is invalid, clear it
      if (error.response?.status === 401) {
        localStorage.removeItem('userToken');
      }
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = async (token, userData = null) => {
    localStorage.setItem('userToken', token);
    
    if (userData) {
      // Ensure permissions is an array
      if (!Array.isArray(userData.permissions)) {
        userData.permissions = [];
      }
      setUser(userData);
    } else {
      await fetchUserData();
    }
  };

  const logout = () => {
    localStorage.removeItem('userToken');
    setUser(null);
  };

  const refreshUser = async () => {
    await fetchUserData();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        login,
        logout,
        refreshUser,
        isAuthenticated: !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
